import React from 'react';
import { Slide } from '@material-ui/core';

const Transition = props => (
  <Slide direction="up" {...props} />
);

export default Transition;
